module.exports = __webpack_public_path__ + "assets/img/5_1152_big.3cf10291.jpg";